import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

/*
  V2.1 · PRIORITÄT 4 — Manifest-Sektion
  Kernstatement: BERLIN ─ CUBE ist kein Produkt.
  BERLIN ─ CUBE entwickelt die Infrastruktur der nächsten Generation.
  Positionierung direkt nach Hero.
*/

export default function Manifest() {
  const { lang } = useLang();
  const copy = {
    de: {
      strike: "Berlin-Cube entwickelt keine Poller.",
      title: "Berlin-Cube entwickelt die Infrastruktur der nächsten Generation.",
      body: "Nicht Produkte stehen im Mittelpunkt. Sondern die kommunalen Herausforderungen.",
    },
    en: {
      strike: "Berlin-Cube does not build bollards.",
      title: "Berlin-Cube builds the infrastructure of the next generation.",
      body: "Products are not the point. Municipal challenges are.",
    },
  }[lang];

  return (
    <section
      id="manifest"
      data-testid="section-manifest"
      className="relative bg-[#1F2328] text-white py-40 md:py-56"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-14">
        <div className="max-w-5xl">
          {/* Strike-through provocation */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="font-display font-light tracking-[-0.02em] text-white/35 leading-[1.15] mb-8 md:mb-12"
            style={{ fontSize: "clamp(1.5rem, 3vw, 2.5rem)" }}
          >
            <span className="relative inline-block">
              {copy.strike}
              <span
                aria-hidden
                className="absolute left-0 right-0 top-1/2 h-px bg-[#F5D77A]/60"
              />
            </span>
          </motion.p>

          {/* Main statement */}
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.2, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="font-display font-light tracking-[-0.035em] leading-[1.02] text-white"
            style={{ fontSize: "clamp(2.5rem, 6.5vw, 6rem)" }}
          >
            {lang === "de" ? (
              <>
                Berlin-Cube entwickelt die{" "}
                <span className="text-[#F5D77A]">Infrastruktur</span>
                <br />
                der nächsten Generation.
              </>
            ) : (
              <>
                Berlin-Cube builds the{" "}
                <span className="text-[#F5D77A]">infrastructure</span>
                <br />
                of the next generation.
              </>
            )}
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.35 }}
            className="mt-12 md:mt-16 text-white/60 leading-relaxed max-w-2xl"
            style={{ fontSize: "clamp(1.05rem, 1.4vw, 1.35rem)" }}
          >
            {copy.body}
          </motion.p>

          {/* Divider line */}
          <motion.div
            initial={{ scaleX: 0, opacity: 0 }}
            whileInView={{ scaleX: 1, opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.4, delay: 0.5 }}
            className="mt-16 md:mt-20 h-px w-32 bg-[#F5D77A] origin-left"
          />
        </div>
      </div>
    </section>
  );
}
